import { FLOW_MODULE } from "@app/models/form-data.interface";

/**
 * Modules that require a responsibility check.
 */
export const modulesWithResponsibilityCheck = [
  FLOW_MODULE.GAS,
  FLOW_MODULE.ELECTRICITY,
];
